import React, { useContext, createContext } from 'react';
import useBlocks from './use';

const BlocksContext = createContext({});
const useBlocksContext = () => useContext(BlocksContext);

const BlocksContextProvider = ({ children }) => {
    const blocks = useBlocks();

    return (
        <BlocksContext.Provider value={blocks}>
            {children}
        </BlocksContext.Provider>
    );
};

export default BlocksContextProvider;
export { useBlocksContext };